module.exports = __webpack_public_path__ + "img/purpleCircle.daa031bf.png";